import { c as _c } from "react/compiler-runtime";
import NProgress from 'nprogress';
import selectTasksPending from '../../store/tasks/selectors/selectTasksPending';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
const useDisplayLoadingBarIfAnyTaskPending = () => {
  const $ = _c(3);
  const hasPendingTasks = useSelector(selectTasksPending);
  let t0;
  let t1;
  if ($[0] !== hasPendingTasks) {
    t0 = () => {
      if (hasPendingTasks) {
        NProgress.start();
      } else {
        NProgress.done();
      }
    };
    t1 = [hasPendingTasks];
    $[0] = hasPendingTasks;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
};
export default useDisplayLoadingBarIfAnyTaskPending;